import $ from 'jquery';
import 'slick-carousel/slick/slick';

export const slider = () => {

    $('.slider-top').slick({
        infinite: false,
        dots: true,
        arrows: true,
        fade: true,
        speed: 0,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    /*
    $('.slider-bottom-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        arrows: false,
        fade: true,
        speed: 0,
        asNavFor: '.slider-bottom-nav'
      });

    $('.slider-bottom-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        rows: 0,
        dots: false,
        arrows: true,
        centerMode: true,
        focusOnSelect: true,
        asNavFor: '.slider-bottom-for'
    });
    */

    $('.slider-bottom-for').each(function(key, item) {

        const sliderIdName = 'slider' + key;
        const sliderNavIdName = 'slider-nav' + key;
      
        this.id = sliderIdName;

        $('.slider-bottom-nav')[key].id = sliderNavIdName;
      
        const sliderId = '#' + sliderIdName;
        const sliderNavId = '#' + sliderNavIdName;
      
        $(sliderId).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            dots: false,
            arrows: false,
            fade: true,
            speed: 0,
            asNavFor: sliderNavId
        });
      
        $(sliderNavId).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 0,
            dots: false,
            arrows: true,
            //centerMode: true,
            focusOnSelect: true,
            asNavFor: sliderId
        });
      
    });
};